import React, { useEffect, useRef, useState } from "react";

import CarAnimationVideo from "assets/video/paypair_loader_car.mp4";
import "./styles.scss";

const LINEAR_RATE = 100 / 50000; // % per ms
const BEND = 85;
const MAX_PROGRESS = 97;
const TICK_MS = 150;

const CarLoader = () => {
  const [progress, setProgress] = useState(0);
  const startRef = useRef(null);

  useEffect(() => {
    startRef.current = Date.now();
    const timer = setInterval(() => {
      const elapsed = Date.now() - startRef.current;
      let estimated = elapsed * LINEAR_RATE;
      if (estimated > BEND) {
        estimated = BEND + (MAX_PROGRESS - BEND) * (1 - Math.exp(-(estimated - BEND) / 10));
      }
      setProgress(Math.min(MAX_PROGRESS, estimated));
    }, TICK_MS);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="car-loader">
      <video
        className="car-loader__animation"
        src={CarAnimationVideo}
        autoPlay
        loop
        muted
        playsInline
        aria-label="Processing your application"
      />
      <div className="car-loader__bar">
        <div className="car-loader__bar-fill" style={{ width: `${progress}%` }} />
      </div>
      <p className="car-loader__percent">{Math.floor(progress)}%</p>
    </div>
  );
};

export default CarLoader;
